export const palavras = [
    { id: 1, palavra: 'papel', significa: 'Tipo de material que deve ser descartado no lixo de coloração azul.' },
    { id: 2, palavra: 'sacola', significa: 'Produto de plástico que deve ser descartado no lixo de coloração vermelha.' },
    { id: 3, palavra: 'verde', significa: 'Cor que deve ser descartado produtos de vidro.' },
    { id: 4, palavra: 'metal', significa: 'Tipo de material que deve ser descartado no lixo de coloração amarela.' },
    { id: 5, palavra: 'eolica', significa: 'Energia obtida da força do vento.' },
    { id: 6, palavra: 'solar', significa: 'Energia obtida pela luz.' },
    { id: 7, palavra: 'hidrogenio', significa: 'Elemento que combinado com o oxigênio produz água e libera energia para ser consumida.' }
]